module.exports = __webpack_public_path__ + "img/chufa_scenariogray_icon.47fdad06.png";